import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { MsalB2CInterceptor } from "./msalb2c.interceptor";

// Der Interceptor-Provider steht bewusst hier und nicht in msalb2c.config.ts: dort erzeugte er
// einen Importzyklus, weil msalb2c.interceptor seinerseits apiAccesses aus msalb2c.config liest.
// Ein solcher Zyklus löst sich nur so lange richtig auf, wie der Bündler das Paar ausschließlich
// über msalb2c.config betritt. Kommt ein zweiter statischer Einstieg auf msalb2c.interceptor
// hinzu, kehrt sich die Auswertungsreihenfolge im gemeinsamen Chunk um: der Rumpf von
// msalb2c.config liest die Klasse vor ihrer Initialisierung, useClass bleibt dauerhaft
// `undefined`, und Angular wirft beim Aufbau JEDES Injectors, der diesen Provider sieht, NG0204
// ("Token HTTP_INTERCEPTORS is missing a ɵprov definition"). Genau das ist passiert: weder der
// Compiler noch ein isolierter Testlauf zeigten etwas, erst im Gesamtlauf fielen acht Tests in
// zwei Dateien um, darunter eine völlig unbeteiligte Fremdspec.
//
// Seit der Trennung führt die Kante nur noch in eine Richtung (Provider -> Interceptor ->
// Konfiguration). Diese Datei darf deshalb nicht wieder in msalb2c.config.ts wandern.
export const interceptorProvider = {
	provide: HTTP_INTERCEPTORS,
	useClass: MsalB2CInterceptor,
	multi: true
};
